import React from 'react';
import {Header, Breadcrumb, Container,Loader, Dropdown, Divider, Form, Dimmer, TextArea,   Button, Grid,Input, Radio} from 'semantic-ui-react';
import { Link } from "react-router-dom";


const TipoMonedaForm=({ id, color, form, onSave,onChange, ajaxCallInProgress, datos, errors={}, strings, permisos})=>{



	return (
        <Container>
          <Dimmer active={ajaxCallInProgress>0?true:false} inverted>
          		<Loader size='big' inline content={strings?strings["Procesando"]:""}/>
          </Dimmer>

				<Header     dividing>             
					<Header.Content>{strings?strings["TipoMoneda"]:""}</Header.Content>
				</Header>
			<Grid container>
                <Grid.Row>
                    <Grid.Column >
                        <Form  >          
                            <Form.Field  required  error={errors.moneda}>            
                              <label  >{strings?strings["moneda"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["moneda"]:""} 
                                    name="moneda"
                                    onChange={onChange}
                                    value={datos.moneda}
                                    icon='edit'/>
                            </Form.Field>
                                            
                        
                                                                        
                            <Divider hidden/>
							  <Grid centered>
                            <Button.Group  >
                                <Link to="/tipomonedas">
                                    <Button  
										>{strings?strings["regresar"]:""}</Button>
                                </Link>
                                <Button.Or text=" "></Button.Or>
                                <Button  color="black"
                                    onClick={onSave}>{strings?strings["guardar"]:""}
								 </Button>
                              </Button.Group>
                            </Grid>
                           <br/>
                        </Form>
                    </Grid.Column>
                </Grid.Row>
                
            
            </Grid>
        
        </Container>
	);
};



export default TipoMonedaForm;